import { CONTRACT_SETUP_ALL_STATE_CLEAR } from '@app/store/actionTypes';
import { ContractSetupAction, setExitRoute } from '@app/store/contract-setup/actions';

export type ContractSetupExitRouteState = '/editing-documents' | '/documents' | '/templates' | '';

const initialState: ContractSetupExitRouteState = '';

export default function reducer(
  state: ContractSetupExitRouteState = initialState,
  action: ContractSetupAction
) {
  switch (action.type) {
    case CONTRACT_SETUP_ALL_STATE_CLEAR:
      return '';
    case setExitRoute.type:
      return action.payload;
    default:
      return state;
  }
}
